import CustomButton from "../../../../components/CustomButton";
import SvgIcon from "../../../../helpers/SvgIcon";
import { useAppDispatch } from "../../../../redux/hooks";
import { setClientSelectedWorkingPoint } from "../../../../redux/reducer/expedition.reducer";

function ClientWorkingPointsActionButton({ crudData }: any) {
  const dispatch = useAppDispatch();

  const handleButtonPress = () => {
    dispatch(setClientSelectedWorkingPoint(crudData));
  };

  return (
    <div>
      <CustomButton
        tooltipTitle="Asociere punct lucru"
        variant="contained"
        onClick={handleButtonPress}>
        <SvgIcon type="WORKING_POINT" fill="white" />
      </CustomButton>
    </div>
  );
}

export default ClientWorkingPointsActionButton;
